/* eslint-disable no-undef */
import { useState, useEffect } from "react";
import DamagesMainPopup from "../popup-containers/DamagesMainPopup";
import TextArea from "../ReusableComponents/TextArea";
import InputText from "../ReusableComponents/InputText";
import AddScreenTitle from "../components/AddScreenTitle";
import Buttons from "../components/Buttons";
import MainLayout from "../components/MainLayout";
import GridPage from "../components/GridPage";
import { mainTable } from "../css/Common";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import { damagesHeader } from "../components/HeaderAttribute";
import { BindPostAPI, IUDAPI } from "../services/APIConnection";
import MainPopup from "../popup-containers/MainPopup";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import toast from "react-hot-toast";
import PopUpButtons from "../components/PopUpButtons";
import UsePrevious from "../Hook/UsePrevious";
import Loader from "../ReusableComponents/Loader";
import ErrorPopup from "../ReusableComponents/ErrorPopup";

const Damages = () => {
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [submitBtnDisabled, setsubmitBtnDisabled] = useState(false);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setupdateScreenTitle] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [damageData, setDamageData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const createdBy = sessionStorage.getItem("createdBy");
  const mstclientId = sessionStorage.getItem("MstClientId");
  const [errors, setErrors] = useState({});
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [TxnDamageId, setTxnDamageId] = useState("");
  const [bindRoomType, setBindRoomType] = useState([]);
  const [bindRoom, setBindRoom] = useState([]);
  const [bindStaff, setBindStaff] = useState([]);
  const [categoryTable, setCategoryTable] = useState([]);
  const [allRooms, setAllRooms] = useState([]);
  const [bindDamagesChildData, setBindDamagesChildData] = useState([]);
  const [itemTypeDropdown, setItemTypeDropdown] = useState([]);
  const [categoryDropdown, setCategoryDropdown] = useState([]);
  const [itemNameDropdown, setItemNameDropdown] = useState([]);
  const [popUpData, setPopUpData] = useState({});
  const [popUpDataDD, setPopUpDataDD] = useState({});
  const [childTableError, setChildTableError] = useState("");

  const getLocalDate = () => {
    const d = new Date();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${d.getFullYear()}-${month}-${day}`;
  };

  const [mstDamageId, setMstDamageId] = useState("");
  const [formFields, setFormFields] = useState({
    DamagesNo: "DAM",
    Date: getLocalDate(),
    RoomType: "",
    Room: "",
    ReportedBy: "",
    Remarks: "",
  });

  const [formFieldsError, setFormFieldsError] = useState({
    DamagesNo: "",
    Date: "",
    RoomType: "",
    Room: "",
    ReportedBy: "",
    Remarks: "",
  });

  const [tableData, setTableData] = useState([
    {
      itemType: "",
      itemCategoryId: "",
      itemId: "",
      quantity: "",
      value: "",
      uom: "",
      itemList: [],
      itemCategoryList: [],
    },
  ]);

  const [bindDamages, setBindDamages] = useState([]);
  const [bindDamageChild, setBindDamageChild] = useState([]);

  const previousTableData = UsePrevious(tableData);

  useEffect(() => {
    BindDamages();
  }, []);

  const BindDamages = async () => {
    try {
      setIsLoading(true);

      const requestData = {
        mstClientId: mstclientId,
      };
      const response = await BindPostAPI(requestData, "DamagesAPI/BindDamages");

      if (response && response.data) {
        const data = response.data;
        console.log("BindResponse Damages", response);

        // Grid data
        setBindDamages(data?.Table || []);
        setBindDamagesChildData(data?.Table1 || []);

        const roomType = (data?.Table5 || []).map((item) => ({
          value: item.MstRoomTypeId,
          label: item.RoomType,
        }));
        setBindRoomType(roomType);

        const room = (data?.Table6 || []).map((item) => ({
          value: item.MstRoomMasterID,
          label: item.RoomName,
          MstRoomTypeId: item.MstRoomTypeId,
        }));
        setAllRooms(room);
        setBindRoom([]);

        const staff = (data?.Table7 || []).map((item) => ({
          value: item.MstStaffId,
          label: item.StaffName,
        }));
        setBindStaff(staff);

        // Dropdowns
        const itemTypeOptions = (data?.Table2 || []).map((item) => ({
          value: item.MstItemTypeId,
          label: item.ItemType,
        }));
        setItemTypeDropdown(itemTypeOptions);
        setCategoryTable(data?.Table2 || []);

        setCategoryDropdown(data?.Table3);

        setItemNameDropdown(data?.Table4);
      } else {
        console.error("BindDamages: Invalid response", response);
      }
    } catch (error) {
      console.error("BindDamages Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (formFields.RoomType) {
      const filteredRooms = allRooms.filter(
        (room) => room.MstRoomTypeId === formFields.RoomType
      );
      setBindRoom(filteredRooms);
    }
  }, [formFields.RoomType, allRooms]);

  const handleEdit = async (rowIndex) => {
    const selectedRow = bindDamages[rowIndex];
    if (!selectedRow) return;
    const selectedTxnId = selectedRow.TxnDamageId;
    setTxnDamageId(selectedTxnId);
    const payload = {
      mstClientId: parseInt(mstclientId, 10),
      txnDamageId: selectedTxnId,
    };
    const response = await BindPostAPI(
      payload,
      "DamagesAPI/BindDamagesChildData"
    );
    // const result = response?.data?.Table?.[0];

    // const relatedRows = bindDamages.filter(
    //   (row) => row.TxnDamageId === selectedTxnId
    // );
    //  ;
    // Split and rearrange
    const [day, month, year] = bindDamages[rowIndex].Date.split("-");
    const formattedDate = `${year}-${month}-${day}`;
    setupdateScreenTitle(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);
    setFormFields({
      ...formFields,
      TxnDamageId: bindDamages[rowIndex].TxnDamageId,
      DamagesNo: bindDamages[rowIndex].DamageNo,
      Date: formattedDate,
      RoomType: bindDamages[rowIndex].MstRoomTypeId,
      Room: bindDamages[rowIndex].MstRoomId,
      ReportedBy: bindDamages[rowIndex].MstStaffId,
      Remarks: bindDamages[rowIndex].Remarks,
    });
    //  ;
    const editChildTableData = response?.data?.Table?.map((row) => ({
      itemType: row.MstItemTypeId || "",
      itemCategoryId: row.MstItemcategoryId || "",
      itemId: row.MstItemId || "",
      quantity: row.Quantity || "",
      value: row.Value || "",
      uom: row.MstUOMId || "",
    }));
    setTableData(editChildTableData);
    //  ;
    const TesttxnDamageId = bindDamages[rowIndex].TxnReceiptId;
    if (!TesttxnDamageId) {
      console.error("TxnDamageId not found");
      return;
    }
    const filtered = bindDamagesChildData.filter(
      (item1) => item1?.TxnDamageId === TesttxnDamageId
    );
    if (filtered.length === 0) {
      setTableData([
        {
          itemType: "",
          itemCategoryId: "",
          itemName: "",
          uom: "",
          quantity: "",
          value: "",
          itemCategoryList: [],
          itemList: [],
        },
      ]);
    } else {
      appendDataToConsumeTable(JSON.stringify(filtered));
    }
  };

  const appendDataToConsumeTable = (newDataString) => {

    const newDataArray = JSON.parse(newDataString);
    handleDeleteRow(0);
    setTableData([]);
    const formattedDataArray = newDataArray.map((data) => {
      return {
        itemType: data.MstItemTypeId,
        itemCategoryId: data.MstItemcategoryId,
        itemName: parseInt(data.MstItemId, 10),
        rate: data.Rate.toString(),
        uom: data.UOM,
        quantity: data.Quantity.toString(),
      };
    });
    setTableData((prevData) => [...prevData, ...formattedDataArray]);
    updateTableData(formattedDataArray);
    convertArrayToJSONString(formattedDataArray);
  };

  const convertArrayToJSONString = (array) => {
    try {
      const jsonString = JSON.stringify(array);
      console.log("data", tableData);
      console.log("JsonString", jsonString);
      return jsonString;
    } catch (error) {
      console.error("Error converting array to JSON string:", error);
      return null;
    }
  };
  useEffect(() => {
    updateTableData();
  }, [tableData]);

  const updateTableData = async () => {

    if (JSON.stringify(previousTableData) !== JSON.stringify(tableData)) {
      const updatedTableData = [...tableData];
      for (const row of updatedTableData) {
        if (row?.itemType) {
          console.log(row.itemType, "rowitemtype");
          const filteredCategories = categoryDropdown
            .filter((item) => item.MstItemTypeId == row.itemType)
            .map((item) => ({
              value: item.MstItemCategoryId,
              label: item.ItemCategory,
            }));
          row.itemCategoryList = filteredCategories;
        }

        if (row?.itemCategoryId) {
          const filteredItems = itemNameDropdown
            .filter((item) => item.MstItemCategoryId == row.itemCategoryId)
            .map((item) => ({
              value: item.MstItemId,
              label: item.ItemName,
              totalStock: item.TotalStock,
              uom: item.UOM,
            }));
          row.itemList = filteredItems;
          const selectedCommodity = filteredItems.find(
            (item) => item.value === row.itemId
          );

          row.uom = selectedCommodity?.uom || "";
          row.totalStock = selectedCommodity?.totalStock || "";
        }
      }
      setTableData(updatedTableData);
    }
  };

  const updateTableData1 = async () => {
    if (JSON.stringify(previousTableData) !== JSON.stringify(tableData)) {
      const updatedTableData = [...tableData];

      for (const row of updatedTableData) {
        if (row?.itemType) {
          const filteredCategories = categoryDropdown
            .filter((item) => item.MstItemTypeId === row.itemType)
            .map((item) => ({
              value: item.MstItemCategoryId,
              label: item.ItemCategory,
            }));
          row.itemCategoryList = filteredCategories;
        }

        if (row?.itemCategoryId) {
          const filteredItems = itemNameDropdown
            .filter((item) => item.MstItemCategoryId === row.itemCategoryId)
            .map((item) => ({
              value: item.MstItemId,
              label: item.ItemName,
              uom: item.UOM,
            }));
          row.itemList = filteredItems;

          const selectedItem = filteredItems.find(
            (item) => item.value === row.itemName
          );
          // (selectedItem available if needed)
        }
      }
      setTableData(updatedTableData);
    }
  };




  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setupdateScreenTitle(false);
    setAddScreenTitle(true);
    setTxnDamageId(""); // clear leftover id from a previous edit

    setFormFields({
      DamagesNo: "DAM",
      Date: getLocalDate(),
      RoomType: "",
      Room: "",
      ReportedBy: "",
      Remarks: "",
    });
  };
  const handleDamages = async (rowIndex, flag) => {
    // open popup
    setpopUpOpen(true);

    // set action flags
    setViewDetails(flag === 1);
    setDeleteDetails(flag === 3);
    setBlockDetails(flag === 4);
    setUnBlockDetails(flag === 5);

    // selected row
    const rowData = bindDamages[rowIndex];
    //   ;
    const selectedTxnId = rowData.TxnDamageId;
    setTxnDamageId(selectedTxnId);
    const payload = {
      mstClientId: parseInt(mstclientId, 10),
      txnDamageId: selectedTxnId,
    };
    const response = await BindPostAPI(
      payload,
      "DamagesAPI/BindDamagesChildData"
    );
    //   ;
    if (!rowData) {
      setDamageData([]);
      setTableData([]);
      return;
    }

    // set popup data
    setPopUpData(rowData);
    setPopUpDataDD(response.data.Table);
  };

  const handleOpen = (isOpen) => {
    setpopUpOpen(isOpen);
  };

  // const handleAutoDropdownChange = (value, name) => {
  //   setFormFields((prevFields) => ({
  //     ...prevFields,
  //     [name]: value,
  //   }));
  // };

  const handleAutoDropdownChange = (value, name) => {

    setFormFields((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "RoomType" && { Room: "" }), // reset Room
    }));

    // 🔥 Filter rooms based on Room Type
    if (name === "RoomType") {
      const filteredRooms = allRooms.filter(
        (room) => room.MstRoomTypeId === value
      );
      setBindRoom(filteredRooms);
    }
  };

  const handleInputChangeForm = (e) => {
    const { name, value } = e.target;
    setFormFields((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const cancel = () => {
    BindDamages();
    setVisibleAdd(false);
    setVisibleTable(true);
    setAddScreenTitle(false);
    setupdateScreenTitle(false);
    setIsLoading(false);
    setpopUpOpen(false);
    setFormFields({
      DamagesNo: "",
      Date: "",
      RoomType: "",
      Room: "",
      ReportedBy: "",
      Remarks: "",
    });
    setFormFieldsError({});
    setErrors({
      DamageNo: "",
      Date: "",
      RoomType: "",
      Room: "",
      ReportedBy: "",
      Remarks: "",
    });
    setChildTableError("")
    setTableData([
      {
        itemType: "",
        itemCategoryId: "",
        itemId: "",
        quantity: "",
        value: "",
        uom: "",
        itemList: [],
        itemCategoryList: [],
      },
    ]);
    setsubmitBtnDisabled(false);
    setIsOpen(false);
    console.log("Form cancelled and reset");
  };
  const showView = (rowIndex, flag) => {
    setpopUpOpen(true);
  };

  const handleInputChangeTable = (selectedOption, rowIndex, columnName) => {
    const value = selectedOption ? selectedOption.value : "";
    setTableData((prevTableData) => {
      const updatedData = [...prevTableData];
      updatedData[rowIndex] = { ...updatedData[rowIndex], [columnName]: value };
      convertArrayToJSONString(updatedData);
      return updatedData;
    });
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    const newErrors = { ...errors };
    if (!value) {
      newErrors[name] = "This field is required";
    } else {
      delete newErrors[name];
    }
    setErrors(newErrors);
  };

  const handleDeleteRow = (index) => {
    if (tableData.length != 1) {
      const newTableData = [...tableData];
      newTableData.splice(index, 1);
      setTableData(newTableData);
    } else {
      setTableData([
        {
          itemType: "",
          itemCategoryId: "",
          itemId: "",
          quantity: "",
          value: "",
          uom: "",
          itemList: [],
          itemCategoryList: [],
        },
      ]);
    }
  };

  const handleAddRow = () => {
    if (tableData.length < 4) {
      setTableData([
        ...tableData,
        {
          itemType: "",
          itemCategoryId: "",
          itemId: "",
          quantity: "",
          value: "",
          uom: "",
        },
      ]);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormFields((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (items, flag) => {


    try {
      setsubmitBtnDisabled(true);
      setIsLoading(true);
      // Submit (Insert / Update)
      if (flag === 1 || flag === 2) {
        const newErrors = {
          Date: formFields.Date ? "" : "Enter Date",
          RoomType: formFields.RoomType ? "" : "Select Room Type",
          Room: formFields.Room ? "" : "Select Room ",
          ReportedBy: formFields.ReportedBy ? "" : "Select ReportedBy",
          // Remarks: formFields.Remarks ? "" : "Enter Remarks",
        };

        setErrors(newErrors);
        const isFormValid = Object.values(newErrors).every((err) => err === "");

        if (!isFormValid) {
          // toast.error("Please enter all mandatory fields.");
          setIsOpen(true)
          setsubmitBtnDisabled(false);
          setIsLoading(false);
          return;
        }
        const validChildRows = tableData.filter(
          (row) =>
            row.itemType &&
            row.itemCategoryId &&
            row.itemId &&
            row.quantity &&
            Number(row.quantity) > 0
        );

        if (validChildRows.length === 0) {
          setChildTableError("Please fill the above Table");
          setIsOpen(true)
          setsubmitBtnDisabled(false);
          setIsLoading(false);
          return;

        }

        setChildTableError("")

        //   ;
        // Prepare Payload
        const payload = {
          mstClientId: parseInt(mstclientId, 10),
          txnDamageId: TxnDamageId ? TxnDamageId : 0,
          DamageNo: formFields.DamagesNo,
          Date: formFields.Date,
          MstRoomTypeId: formFields.RoomType,
          MstRoomId: formFields.Room,
          MstStaffId: formFields.ReportedBy,
          Remarks: formFields.Remarks,
          CreatedBy: parseInt(createdBy),
          Flag: flag,
          DamageChild: JSON.stringify(
            tableData.map((row) => ({
              itemType: row.itemType,
              itemCategoryId: row.itemCategoryId,
              itemId: row.itemId,
              uomId: row.uom.toString(),
              quantity: row.quantity,
              value: row.value,
            }))
          ),
        };
        console.log("Payload =>", payload);

        const response = await IUDAPI(payload, "DamagesAPI/IUDDamages");
        const result = response?.data?.Table?.[0]?.Result;
        console.log("API Response =>", response);

        if (flag === 1 && result === "S") {
          toast.success(" Added Successfully 👍");
        } else if (flag === 2 && result === "M") {
          toast.success(" Updated Successfully 👍");
        } else {
          toast.error("Failed to save  👎");
        }

        setTimeout(cancel, 2000);
      } else {
        const data = {
          mstDamageId: formFields.mstDamageId,
          createdby: parseInt(createdBy),
          flag,
        };
        const response = await IUDAPI(data, "DamagesAPI/IUDDamages");
        const result = response?.data?.Table?.[0]?.Result;

        if (flag === 3 && result === "D") {
          toast.success("Deleted successfully 🗑️");
        } else if (flag === 4 && result === "B") {
          toast.success("Inactivated successfully 🚫");
        } else if (flag === 5 && result === "UB") {
          toast.success("Activated successfully ✅");
        } else {
          toast.error("Operation failed 👎");
        }

        setTimeout(cancel, 2000);
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      toast.error("Something went wrong 👎");
    } finally {

      setsubmitBtnDisabled(false);
    }
  };

  // 🔧 keep handlePopup but NO return here (avoids nesting the component UI)
  const handlePopup = (rowIndex) => {
    // previously called setRoomType(rowIndex) which doesn't exist; left empty intentionally
  };

  return (
    <MainLayout pageName={"3"}>
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title="Damages"
          header={damagesHeader}
          records={bindDamages}
          blockView={true}
          handleEdit={handleEdit}
          handleAction={handleDamages}
          showAdd={showAdd}
          onLaundryIssueView={showView}
        />
      )}

      {visibleAdd && (
        <div className="w-full">
          <div className={mainTable.clientMasterMainAdd}>
            <AddScreenTitle
              title="Damages"
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
            />
          </div>

          <div className="grid gap-5 mb-10 md:grid-cols-5">
            <InputText
              title="Damages No"
              name="DamageNo"
              placeholder="DAM"
              content={formFields.DamagesNo}
              disabled={true}
              controlFunc={handleInputChangeForm}
              controlFuncBlur={handleBlur}
              errorMessage={errors.DamageNo}
              classStar="text-red-500"
            />
            <InputText
              inputType="date"
              title="Date"
              name="Date"
              content={formFields.Date}
              classStar="text-red-500"
              controlFunc={handleInputChangeForm}
              controlFuncBlur={handleBlur}
              errorMessage={errors.Date}
            />
            <AutoDropDown
              name="RoomType"
              title="Room Type"
              options={bindRoomType}
              placeholder="Select Name"
              Class="custom-class"
              disabled={false}
              classStar="text-red-500"
              controlFunc={(value, e) =>
                handleAutoDropdownChange(value.value, "RoomType")
              }
              selectedOption={
                formFields.RoomType
                  ? bindRoomType.find((x) => x.value == formFields.RoomType)
                  : ""
              }
              errorMessage={errors.RoomType}
            />
            <AutoDropDown
              name="Room"
              title="Room"
              options={bindRoom}
              placeholder="Select Name"
              Class="custom-class"
              disabled={false}
              classStar="text-red-500"
              controlFunc={(value, e) =>
                handleAutoDropdownChange(value.value, "Room")
              }
              selectedOption={
                formFields.Room
                  ? bindRoom.find((x) => x.value == formFields.Room)
                  : ""
              }
              errorMessage={errors.Room}
            />
            <AutoDropDown
              name="ReportedBy"
              title="Reported By"
              options={bindStaff}
              placeholder="Select Name"
              Class="custom-class"
              disabled={false}
              classStar="text-red-500"
              controlFunc={(value, e) =>
                handleAutoDropdownChange(value.value, "ReportedBy")
              }
              selectedOption={
                formFields.ReportedBy
                  ? bindStaff.find((x) => x.value == formFields.ReportedBy)
                  : ""
              }
              errorMessage={errors.ReportedBy}
            />
          </div>

          <div className="shadow-md p-4 rounded-md bg-white overflow-y-auto h-96">
            <form onSubmit={handleSubmit}>
              <table className="min-w-full table-auto border border-gray-300">
                <thead className="bg-[#3D6643] text-white sticky top-0 z-10">
                  <tr>
                    <th className="border px-2 py-2 w-[30px]">SN</th>
                    <th className="border px-4 py-2 w-[230px]">Item Type</th>
                    <th className="border px-4 py-2 w-[230px]">Category</th>
                    <th className="border px-4 py-2 w-[230px]">Item</th>
                    <th className="border px-4 py-2 w-[100px]">Quantity</th>
                    <th className="border px-4 py-2 w-[100px]">U.O.M</th>
                    <th className="border px-4 py-2 w-[100px]">Value</th>
                    <th className="border px-4 py-2">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((row, index) => (
                    <tr key={index}>
                      <td className="border px-2 py-2">{index + 1}</td>
                      <td className="border px-4 py-2">
                        <AutoDropDown
                          name="itemType"
                          Class="custom-class"
                          options={itemTypeDropdown}
                          selectedOption={
                            itemTypeDropdown.find(
                              (opt) => opt.value === row.itemType
                            ) || null
                          }
                          controlFunc={(e) =>
                            handleInputChangeTable(e, index, "itemType", true)
                          }
                        />
                      </td>
                      <td className="border px-4 py-2">
                        <AutoDropDown
                          name="itemCategoryId"
                          Class="custom-class"
                          options={row.itemCategoryList || []}
                          selectedOption={
                            row?.itemCategoryList
                              ? row?.itemCategoryList?.find(
                                (opt) => opt.value === row.itemCategoryId
                              ) || null
                              : null
                          }
                          controlFunc={(e) =>
                            handleInputChangeTable(
                              e,
                              index,
                              "itemCategoryId",
                              true
                            )
                          }
                        />
                      </td>
                      <td className="border px-4 py-2">
                        <AutoDropDown
                          name="itemId"
                          Class="custom-class"
                          options={row.itemList}
                          selectedOption={
                            row?.itemList
                              ? row.itemList.find(
                                (opt) => opt.value === row.itemId
                              ) || null
                              : null
                          }
                          controlFunc={(e) =>
                            handleInputChangeTable(e, index, "itemId", true)
                          }
                        />
                      </td>

                      <td className="border px-4 py-2" title={`Max Stock: ${row.totalStock || 0}`}>

                        <InputText
                          name="quantity"
                          content={row.quantity}
                          controlFunc={(e) => {
                            const InputText = e.target.value;

                            // Do not allow more than currentStock
                            if (
                              parseInt(InputText || 0) >
                              (row.totalStock || 0)
                            )
                              return;



                            if (/^[0-9]*$/.test(InputText)) {
                              handleInputChangeTable(
                                e.target,
                                index,
                                "quantity"
                              );
                            }
                          }}
                        />

                      </td>
                      <td className="border px-4 py-2">
                        <InputText
                          name="uom"
                          content={row.uom}
                          disabled={true}
                          controlFunc={(e) =>
                            handleInputChangeTable(e, index, "uom")
                          }
                        />
                      </td>
                      <td className="border px-4 py-2">
                        <InputText
                          name="value"
                          content={row.value}
                          controlFunc={(e) => {
                            const InputText = e.target.value;

                            if (/^[0-9]*$/.test(InputText)) {
                              handleInputChangeTable(e.target, index, "value");
                            }
                          }}
                        />
                      </td>
                      <td className="border px-4 py-2">
                        <div className="flex gap-4 items-center justify-center">
                          <svg
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            className="w-6 h-6 text-black cursor-pointer"
                            onClick={() => handleDeleteRow(index)}
                          >
                            <path d="M6 2l2-2h4l2 2h4v2H2V2h4zM3 6h14l-1 14H4L3 6zm5 2v10h1V8H8zm3 0v10h1V8h-1z" />
                          </svg>
                          {index === tableData.length - 1 &&
                            tableData.length < 4 && (
                              <svg
                                viewBox="0 0 1024 1024"
                                fill="currentColor"
                                onClick={handleAddRow}
                                className="w-6 h-6 text-black cursor-pointer"
                              >
                                <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z" />
                              </svg>
                            )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {childTableError && (
                <p className="text-red-600 font-semibold text-sm mt-4">
                  {childTableError}
                </p>
              )}
              <div className="md:col-span-3"></div>
              <TextArea
                title="Remarks"
                name="Remarks"
                placeholder="Remarks"
                rows={3}
                maxLength={500}
                // tabIndex="1"
                content={formFields.Remarks}
                controlFunc={handleInputChangeForm}
              />

              <div className="flex justify-center mt-6 gap-4">
                <Buttons
                  addScreenTitle={addScreenTitle}
                  updateScreenTitle={updateScreenTitle}
                  viewSaveButton={false}
                  handleSubmit={handleSubmit}
                  disabledBtn={submitBtnDisabled}
                  cancel={cancel}
                />
              </div>
            </form>
          </div>
        </div>
      )} {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handleDamages}
      >
        <div>
          <PopUpScreenTitle
            title="Damages"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <DamagesMainPopup data={popUpData} data1={popUpDataDD} />
        </div>
        <PopUpButtons deleteDetails={deleteDetails}
          viewDetails={viewDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}

          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled} />
      </MainPopup>
    </MainLayout>
  );
};
export default Damages;
